<div class="veify-email-failed-container">
  <img src="assets/generalImage/email_verify_failed.svg" alt="mascot" />

  <p class="desc">{{'desc.email.verification.failed' | translate}}</p>

  <app-button [textButton]="true" [buttonName]="'button.retry'" (click)="resendVerificationLink()"></app-button>
</div>
